import { render } from "./PerkItemCard.vue?vue&type=template&id=4f5d6e82"
import script from "./PerkItemCard.vue?vue&type=script&lang=js"
export * from "./PerkItemCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Merlin.Website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__